import Box from '@mui/material/Box';
import { useThemeStore } from '../../../store/theme';
import { AppOperator } from '../../../types/theme.types';

export const useOperatorLogo = () => {
  const operator = useThemeStore((s) => s.operator);

  const getOperatorLogo = () => {
    switch (operator) {
      case AppOperator.TAURON:
        return <img height={40} width={40} src="/images/tauron-logo.png" alt="tauron" />;
      case AppOperator.ENEA:
        return (
          <Box
            sx={{
              backgroundColor: 'white',
              borderRadius: 1,
              padding: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img height={30} width={50} src="/images/enea-logo.png" alt="enea" />
          </Box>
        );
      case AppOperator.DEFAULT:
      default:
        return null;
    }
  };

  return {
    getOperatorLogo,
  };
};
